/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUpgrade.vue?vue&type=template&id=4b9cefe2&scoped=true"
import script from "./popUpgrade.vue?vue&type=script&lang=js"
export * from "./popUpgrade.vue?vue&type=script&lang=js"
import style0 from "./popUpgrade.vue?vue&type=style&index=0&id=4b9cefe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9cefe2",
  null
  
)

export default component.exports